import React, { memo, useMemo } from "react";
import { Icon } from '../../components';
import { StripeConnect as StripeConnectIcon } from '../../icons'
import { useMfwThemeProvider } from "myfitworld-utils";


const StripeConnect = () => {
  const strokeColor = useMfwThemeProvider().mfwMuiWebTheme.palette.text.primary;

  const styes = useMemo(() => {
    return { stroke: strokeColor, fill: strokeColor }
  }, [strokeColor])

  return (
    <Icon icon={StripeConnectIcon} style={styes} />
  );
};

export default memo(StripeConnect);
